<template>
    <el-dialog :title="title"
               :visible.sync="showDialog"
               custom-class="x-dialog-notifications"
               :show-close="false"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               width="600px">
        <div style="display: flex;">
            <div style="margin-right: 16px">
                <i class="fas fa-triangle-exclamation" style="font-size: 64px; color: red;"></i>
            </div>
            <div class="message">{{ message }}</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="confirmedNotification">Confirmar</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            showDialog: false,
            title: '',
            message: '',
            confirmed: false,
            certificate_due: []
        }
    },
    mounted() {
        this.getNotifications()
    },
    methods: {
        async getNotifications() {
            await this.$http.get(`/notifications`)
                .then(response => {
                    let data = response.data
                    this.certificate_due = data.certificate_due
                    this.showNotifications()
                })
                .catch(error => {
                })
                .then(() => {
                })
        },
        showNotifications() {
            if (this.certificate_due.show) {
                this.title = this.certificate_due.title
                this.message = this.certificate_due.message
                this.confirmed = this.certificate_due.confirmed
                this.showDialog = true
            }
        },
        confirmedNotification() {
            this.showDialog = false
            if (this.confirmed) {
                this.$http.post(`/notifications/confirmed`, {
                    date: this.certificate_due.date,
                    type: 'certificate_due'
                })
                    .then(response => {
                    })
                    .catch(error => {
                    })
                    .then(() => {
                    })
            }
        }
    }
}
</script>
